import Vue from 'vue';

export default {
    getReferences(context, data) {
        const url = 'v1/me/reference';
        return Vue.$axios.$get(url, data);
    },

    storeReference(context, data) {
        const url = 'v1/me/reference';
        return Vue.$axios.$post(url, data);
    },

    updateReference(context, { id, data }) {
        const url = `v1/me/reference/${id}`;
        return Vue.$axios.$put(url, data);
    },

    destroyReference(context, id) {
        const url = `v1/me/reference/${id}`;
        return Vue.$axios.$delete(url);
    },

    saveReferenceOrder(context, data) {
        const url = 'v1/me/reference-order';
        return Vue.$axios.$post(url, data);
    },
};
